import { createReducer } from '@reduxjs/toolkit'
import * as usersActions from '../actions/users'
import { APIData, APIStatus } from '../axiosConfiguration'
import { UserCompanyData, UserManagementData } from '../type/users'

type userManageState = {
  users: APIData<UserManagementData>
  companies: APIData<UserCompanyData[]>
  inviteStatus: APIStatus
}

const initialState: userManageState = {
  users: { status: APIStatus.IDLE },
  companies: { status: APIStatus.IDLE },
  inviteStatus: APIStatus.IDLE,
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(usersActions.getUsers.fulfilled, (state, action) => {
      state.users.status = APIStatus.FULFILLED
      state.users.data = action.payload
    })
    .addCase(usersActions.getUsers.rejected, (state, action) => {
      state.users.status = APIStatus.REJECTED
      state.users.error = action.payload
    })
    .addCase(usersActions.getUsers.pending, (state) => {
      state.users.status = APIStatus.PENDING
    })

  builder
    .addCase(usersActions.getUserCompaniesAssociations.fulfilled, (state, action) => {
      state.companies.status = APIStatus.FULFILLED
      state.companies.data = action.payload
    })
    .addCase(usersActions.getUserCompaniesAssociations.rejected, (state, action) => {
      state.companies.status = APIStatus.REJECTED
      state.companies.error = action.payload
    })
    .addCase(usersActions.getUserCompaniesAssociations.pending, (state) => {
      state.companies.status = APIStatus.PENDING
    })

  builder
    .addCase(usersActions.sendUserInvite.pending, (state) => {
      state.inviteStatus = APIStatus.PENDING
    })
    .addCase(usersActions.sendUserInvite.fulfilled, (state) => {
      state.inviteStatus = APIStatus.FULFILLED
    })
    .addCase(usersActions.sendUserInvite.rejected, (state) => {
      state.inviteStatus = APIStatus.REJECTED
    })
    .addCase(usersActions.clearUserInvite, (state) => {
      state.inviteStatus = APIStatus.IDLE
    })
})
